<template>
    <div>
        <div class="row mt-4">
            <label for="lessonNameInput" style="font-size: 16px;color: #1A0054;">
                <strong><i class="fa-regular fa-file"></i> Nombre de la lección</strong>
            </label>
            <input v-model="activeLesson.name" type="text" id="lessonNameInput" class="form-control rounded-8 sin-borde" placeholder="Lección 1">
        </div>

        <div class="row mt-4">
            <div class="px-0" >
                <label class="label-lesson">Descripción de la lección</label>
                <Editor
                    style="border-radius: 20px;"
                    v-model="activeLesson.description"
                    :init="{ height: 200, plugins: 'lists link image media table code help wordcount'}"
                    api-key="7e2p05jxa7jv18llddo0a1ixlh1sv18nkxu6guxbe8etd8mt"
                />
            </div>
        </div>

        <div class="row mt-4">
            <label class="label-lesson" for="">Duración de la lección</label>
            <div class="d-flex p-0">
                <div class="col-md-4 ps-0">
                    <input type="number" v-model="activeLesson.durationLength" class="form-control sin-borde rounded-8" placeholder="Duración">
                </div>
                <div class="col-md-8 pe-0">
                    <select class="form-control sin-borde rounded-8" v-model="activeLesson.durationType">
                        <option value="minutos" selected>Minuto(s)</option>
                        <option value="horas">Hora(s)</option>
                        <option value="dias">Día(s)</option>
                        <option value="semanas">Semana(s)</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="d-flex mt-4 justify-content-end pb-3">
            <button class="btn rounded-8 sin-borde text-primary mx-2 px-5" @click="cancelSaving">Cancelar</button>
            <button
                class="btn custombutton bg-utel rounded-8 text-white px-5"
                @click="saveLesson"
                :disabled="isButtonDisabled"
            >Guardar</button>
        </div>
    </div>
</template>
<script>
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import Editor from '@tinymce/tinymce-vue';

    export default {
        props: ['lesson'],
        components: {
            vueDropzone: vue2Dropzone,
            Editor
        },
        data(){
            return {
                dropzoneOptions: {
                    url: window.location.href,
                    addRemoveLinks: true,
                    thumbnailWidth: 150,
                    resizeWidth: 1024,
                    capture: true,
                    uploadMultiple: false,
                    maxFiles: 1,
                    autoProcessQueue: false
                },
                activeLesson: this.lesson,
            }
        },
        computed: {
            isButtonDisabled(){
                return this.activeLesson.name.trim() === ''
                    || this.activeLesson.durationLength.trim() === ''
                    || this.activeLesson.durationType.trim() === '';
            },
            isFileSelected(){
                return !!this.activeLesson.file;
            }
        },
        methods: {
            cancelSaving(){
                this.$emit('onCancel');
            },
            saveLesson(){
                this.$emit('onSave', this.activeLesson)
            },
            handleDrop(file){
                this.activeLesson.file = file;
            },
            getMbFileSize(){
                return (this.activeLesson.file.size / (1024 * 1024)).toFixed(3);
            },
            deleteFile(){
                this.activeLesson.file = null;
            },
            downloadFile(){
                const url = this.activeLesson.file.dataURL;
                const fileName = this.activeLesson.file.name;
                const link = document.createElement('a');
                link.href = url;
                link.download = fileName;

                link.click();
            }
        }
    }
</script>
<style>
    .label-lesson{
        color: #494949;
        font-size: 16px;
    }

    .dropzone-icon{
        color: #BCB7D1;
        border: 3px solid #BCB7D1;
        border-radius: 50%;
        padding: 10px;
        width: 65px;
        height: 65px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .dropzone-text{
        color: #6B6876;
        font-size: 14px;
        font-weight: 400;
    }

    .dropzone-content-container{
        border: 1px dashed #BCB7D1;
    }

    .custombutton:disabled{
        background-color: #BCB7D1 !important;
        color: #6B6876 !important;
    }

    .bg-outline-primary{
        border: 1px solid #4000BC;
    }

    .file-preview{
        flex-wrap: wrap;
    }

    .file-preview-name{
        color: #494949;
        font-size: 16px;
        font-weight: bold;
    }

    .file-preview-content{
        overflow: hidden;
    }

    .file-preview-size{
        font-size: 14px;
    }

    .rounded-14{
        border-radius: 14px;
    }

    .fa-1-5-x{
        font-size: 1.5em;
    }

    .rounded-15{
        border-radius: 1.5em;
    }
</style>
